<!--
 * @Author: zl
 * @Date: 2021-07-23
 * @LastEditTime: 2022-10-14 17:52:49
 * @LastEditors: Please set LastEditors
 * @Description: 专家信息变更审核
   @修改描述： 专家信息变更优化
   @修改时间： 2022-4-22 16:20:55
   @Edited by 钱磊

-->
<template>
	<div class="review-zj-layout">
		<div class="content" :class="{ elFormBottom: rowData.status != 0 }">
			<el-collapse v-model="activeName">
				<el-collapse-item title="#1 专家基本信息" name="1">
					<el-row :gutter="10">
						<el-form ref="baseForm" :model="baseForm" label-width="110px" class="topForm" size="small">
							<el-col :span="12">
								<el-form-item label="姓名 :">
									{{ baseForm.sname || '无' }}
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="性别 :">
									<!-- {{ baseForm.sex == 1 ? "男" : "女" || "无" }} -->
									{{ baseForm.sex }}
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="身份证号码 :">
									{{ baseForm.idCard || '无' }}
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="年龄：">
									{{ baseForm.age || '无' }}
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="手机号：">
									{{ baseForm.phone || '无' }}
								</el-form-item>
							</el-col>
						</el-form>
					</el-row>
				</el-collapse-item>
				<el-collapse-item title="#2 专家认证信息变更" name="2">
					<el-row :gutter="10">
						<el-form ref="changeForm" :model="baseForm" label-width="110px" size="small">
							<el-col :span="baseForm.fieldName == 'sysExpertOffer' ? 9 : 10">
								<el-form-item label="类型：">
									{{ [2, 6].includes(baseForm.changeType) ? (baseForm.changeType === 2 ? '变更' : '新增') : '变更' }}
								</el-form-item>
							</el-col>
							<el-col :span="14">
								<div class="title-box">
									<span>标题：</span>
									{{ baseForm.title }}
								</div>
							</el-col>
							<el-col :span="24" class="borderBottom">
								<el-form-item label="原内容：">
									<div v-if="![2, 6].includes(baseForm.changeType)">
										{{ baseForm.beforeContent }}
									</div>
									<div v-else>
										<template v-if="baseForm.changeType === 2">
											<el-col :span="baseForm.fieldName == 'sysExpertOffer' ? 6 : 8">
												<div v-if="!isPdfBefore" :class="{ 'img-box': baseForm.beforeFile != '' }">
													<i
														class="el-icon-search icons"
														@click="doView('old', baseForm.beforeFileName)"
														v-if="baseForm.beforeFile != ''"
													></i>
													<img :src="beforeFile" class="show-img" alt="原附件" v-if="baseForm.beforeFile != ''" />
													<div v-if="baseForm.beforeFile == ''">
														<span style="opacity: 0">3231</span>
													</div>
												</div>
												<div v-else class="blue-text" @click="doView('old', baseForm.beforeFileName)">
													<TextTooltip refName="beforeFile" :content="this.curTypeBefore"></TextTooltip>
												</div>
											</el-col>
											<el-col :span="baseForm.fieldName == 'sysExpertOffer' ? 6 : 8">
												{{ baseForm.beforeContent1 }}
											</el-col>
											<el-col :span="baseForm.fieldName == 'sysExpertOffer' ? 6 : 8">
												{{ baseForm.beforeContent2 }}
											</el-col>
											<el-col
												:span="baseForm.fieldName == 'sysExpertOffer' ? 6 : 8"
												v-if="baseForm.fieldName == 'sysExpertOffer'"
											>
												{{ baseForm.beforeContent3 }}
											</el-col>
										</template>
										<div v-else>-</div>
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item
									:label="
										[2, 6].includes(baseForm.changeType)
											? baseForm.changeType === 2
												? '变更后内容：'
												: '新增内容：'
											: '变更后内容：'
									"
								>
									<template v-if="![2, 6].includes(baseForm.changeType)">
										<span class="mr30">{{ baseForm.afterContent }}</span>
										<span class="sp-tip w85" v-if="rowData.status != 0 && baseForm.autoResults">
											变更后手机号（{{ baseForm.afterContent }}）， 手机号本人归属验证结果：
											<span :class="customClass(baseForm.autoResults)">
												{{ baseForm.autoResults }}
											</span>
										</span>
									</template>
									<template v-else>
										<el-col :span="baseForm.fieldName == 'sysExpertOffer' ? 6 : 8">
											<div v-if="!isPdfAfter" :class="{ 'img-box': baseForm.afterFile != '' }">
												<i
													class="el-icon-search icons"
													@click="doView('new', baseForm.afterFileName)"
													v-if="baseForm.afterFile != ''"
												></i>
												<img :src="nowUrl" class="show-img" alt="变更后附件" v-if="baseForm.afterFile != ''" />
												<div v-if="baseForm.afterFile == ''">
													<span style="opacity: 0">3231</span>
												</div>
											</div>
											<div v-else class="blue-text" @click="doView('new', baseForm.afterFileName)">
												<TextTooltip refName="afterFile" :content="this.curTypeAfter"></TextTooltip>
											</div>
										</el-col>
										<el-col :span="baseForm.fieldName == 'sysExpertOffer' ? 6 : 8">
											{{ baseForm.afterContent1 }}
										</el-col>
										<el-col :span="baseForm.fieldName == 'sysExpertOffer' ? 6 : 8">
											{{ baseForm.afterContent2 }}
										</el-col>
										<el-col :span="baseForm.fieldName == 'sysExpertOffer' ? 6 : 8" v-if="baseForm.fieldName == 'sysExpertOffer'">
											{{ baseForm.afterContent3 }}
										</el-col>
									</template>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item
									:label="
										[2, 6].includes(baseForm.changeType)
											? baseForm.changeType === 2
												? '变更原因：'
												: '新增原因：'
											: '变更原因：'
									"
								>
									{{ baseForm.reason }}
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="申请人：">
									{{ baseForm.applyUser }}
								</el-form-item>
							</el-col>
							<el-col :span="24" class="borderBottom">
								<el-form-item label="申请时间：">
									{{ rowData.createDate }}
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item v-if="rowData.status == 0 && baseForm.autoResults">
									<span class="sp-tip">
										变更后手机号（{{ baseForm.afterContent }}）， 手机号本人归属验证结果：
										<span :class="customClass(baseForm.autoResults)">
											{{ baseForm.autoResults }}
										</span>
									</span>
								</el-form-item>
								<el-form-item label="审核结果：" prop="status" :rules="rowData.status == 0 ? requiredRule : []">
									<el-select v-model="baseForm.status" placeholder="请选择..." v-if="rowData.status == 0">
										<el-option label="通过" :value="1"></el-option>
										<el-option label="驳回" :value="2"></el-option>
									</el-select>
									<span v-else>{{ rowData.status === 1 ? '通过' : '驳回' }}</span>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="审核意见：" prop="remark" :rules="rowData.status == 0 ? requiredRule : []">
									<el-input
										type="textarea"
										v-if="rowData.status == 0"
										v-model="baseForm.remark"
										maxlength="200"
										show-word-limit
										:autosize="{ minRows: 5 }"
										placeholder="请输入..."
									></el-input>
									<span v-else>{{ rowData.remark }}</span>
								</el-form-item>
							</el-col>
							<template v-if="rowData.status != 0">
								<el-col :span="24">
									<el-form-item label="审核人：">
										{{ rowData.updateUser }}
									</el-form-item>
								</el-col>
								<el-col :span="24">
									<el-form-item label="审核时间：">
										{{ rowData.updateDate }}
									</el-form-item>
								</el-col>
							</template>
						</el-form>
					</el-row>
				</el-collapse-item>
			</el-collapse>
		</div>
		<div class="zj-check-footer" v-if="rowData.status == 0">
			<el-button class="btn" size="small" @click="doCancel">取 消</el-button>
			<el-button type="primary" class="btn btn-blue" size="small" :loading="btnLoading" @click="doCheck">确 认</el-button>
		</div>

		<!-- 图片预览 -->
		<el-dialog
			:visible.sync="dialogObj.visible"
			title="图片预览"
			custom-class="preview-dialog"
			append-to-body
			top="10vh"
			center
			width="80%"
		>
			<img class="preview-img" :src="dialogObj.imgUrl" alt="" />
		</el-dialog>
	</div>
</template>
<script>
import TextTooltip from '@/views/operation-management/audit-affairs-new/components/TextTooltip'
import { getRecordDetail, auditZjMsg } from 'api/modules/audit'
import { mapState } from 'vuex'
import { auditSubmit } from '@/api/modules/invoice'
import VUE_CONFIG from '../../../../../vue.config.js'
export default {
	name: '',
	components: { TextTooltip },
	props: {
		rowData: {
			type: Object,
			deafault: () => {
				return {}
			}
		}
	},
	data() {
		return {
			activeName: ['1', '2'],
			// 专家基本信息
			baseForm: {
				sname: '', //专家姓名
				sex: '', // 性别
				idCard: '', // 身份证
				age: '', // 年龄
				phone: '', //身份证
				title: '', // 标题
				beforeContent1: '', // 图片变更 原内容1
				beforeContent2: '', // 图片变更 原内容2
				beforeFile: '', // 图片变更 原来附件 url
				beforeContent: '', //原内容
				afterContent1: '', // 图片变更 变更后内容1
				afterContent2: '', // 图片变更 变更后内容2
				afterFile: '', // 图片变更 变更后附件 url
				afterContent: '', //变更后内容
				reason: '', //变更原因
				applyUser: '', //申请人
				applyDate: '', //申请时间
				remark: '', //审核意见
				status: '' //审核状态
			},
			btnLoading: false,
			requiredRule: [{ required: true, message: '不能为空...', trigger: 'blur' }],
			nowUrl: '',
			beforeFile: '',
			isPdfAfter: false, //是不是pdf 变更后
			isPdfBefore: false, //是不是pdf 变更前
			curTypeAfter: '', //附件名 变更后
			curTypeBefore: '', //附件名 变更前
			dialogObj: {
				visible: false,
				imgUrl: ''
			}
		}
	},
	created() {
		this.getExpertInfo()
	},
	methods: {
		// 获取专家信息
		getExpertInfo() {
			getRecordDetail({
				recordId: this.rowData.id,
				id: this.rowData.id
			}).then((res) => {
				res.data.remark = ''
				res.data.status = ''
				this.baseForm = Object.assign({}, res.data)
				this.rowData.status ? '' : (this.baseForm.status = '')
				if (this.baseForm.changeType == 2 || this.baseForm.changeType == 6) {
					this.curTypeAfter = res.data.afterFile.substring(res.data.afterFile.lastIndexOf('/') + 1)
					this.curTypeBefore = res.data.beforeFile.substring(res.data.beforeFile.lastIndexOf('/') + 1)
					this.isPdfAfter = this.curTypeAfter.substring(this.curTypeAfter.lastIndexOf('.') + 1).toUpperCase() == 'PDF' ? true : false
					this.isPdfBefore = this.curTypeBefore.substring(this.curTypeBefore.lastIndexOf('.') + 1).toUpperCase() == 'PDF' ? true : false
					this.nowUrl = this.$uploadUrl + res.data.afterFile
					this.beforeFile = this.$uploadUrl + res.data.beforeFile
				}
			})
		},

		// 取消
		doCancel(data) {
			this.$emit('closeZjCheck', data)
		},

		// 确认
		doCheck() {
			this.$refs.changeForm.validate((valid) => {
				if (valid) {
					this.btnLoading = true
					auditSubmit({
						id: this.rowData.id,
						status: this.baseForm.status, //状态
						remark: this.baseForm.remark, //意见
						busId: this.rowData.busId,
						busType: this.rowData.busType
					})
						.then((res) => {
							this.$message.success('操作完成！')
							this.btnLoading = false
							this.doCancel(true)
						})
						.catch(() => {
							this.btnLoading = false
						})
				} else {
					this.$message.error('请完善表单！')
				}
			})
		},

		// 截取字符串
		extractFilename(pathStr) {
			const lastSlashIndex = pathStr.lastIndexOf('/')
			// 处理没有斜杠的情况
			if (lastSlashIndex === -1) {
				return pathStr
			}
			return pathStr.substring(lastSlashIndex + 1)
		},
		// 查看大图
		doView(type, fileName) {
			let _name = fileName
			let uploadUrl = ''
			// 本地环境代理后无法直接获取路径
			if (process.env.VUE_APP_UPLOAD_URL == '/uploadApi') {
				uploadUrl = VUE_CONFIG.devServer.proxy['/uploadApi'].target
			} else {
				uploadUrl = process.env.VUE_APP_UPLOAD_URL
			}
			let path = type == 'old' ? this.baseForm.beforeFile : this.baseForm.afterFile

			// 预览
			this.dialogObj.imgUrl = uploadUrl + path
			this.dialogObj.visible = true
		}
	},
	computed: {
		...mapState('user', {
			userInfo: (state) => state.userInfo
		}),
		customClass() {
			return function(data) {
				let className = data == '通过' ? 'blueColor' : 'redColor'
				return className
			}
		}
	}
}
</script>
<style lang="less" scoped>
.review-zj-layout {
	min-height: 600px;
	.el-collapse {
		padding-bottom: 30px;
		border-bottom: none;
		.el-collapse-item {
			margin-bottom: 15px;
		}
		/deep/ .el-collapse-item__header {
			padding-left: 15px;
			font-size: 16px;
			background-color: #eff6fe;
		}
		/deep/ .el-collapse-item__wrap {
			border-bottom: none;
		}
		/deep/ .el-collapse-item__content {
			padding: 15px;
		}
	}
	.top-form {
		.el-form-item {
			margin-bottom: 5px !important;
		}
	}
	.zj-check-footer {
		width: 95%;
		position: absolute;
		bottom: 0;
		padding: 10px;
		border-top: 1px solid #eee;
		text-align: center;
		background-color: #fff;
	}
	.borderBottom {
		border-bottom: 2px dashed #eee;
		margin-bottom: 10px;
	}
	.show-img {
		width: 100px !important;
		height: 100px !important;
		border-radius: 5px;
		border: 1px solid #eee;
	}
	.img-box {
		width: 110px;
		height: 110px;
		padding: 5px;
		position: relative;
	}
	.icons {
		font-size: 20px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		color: #fff;
		display: none;
		z-index: 9999;
		cursor: pointer;
	}
	.img-box:hover {
		img {
			cursor: pointer;
			filter: blur(1px) contrast(0.5) brightness(0.8);
		}
		.icons {
			display: block;
		}
	}
	.blue-text {
		color: #2671cc !important;
		cursor: pointer;
	}
	.elFormBottom {
		.el-form-item {
			margin-bottom: 5px !important;
		}
	}
	.sp-tip {
		display: inline-block;
		padding: 0 15px;
		width: 100%;
		background: #f2f2f2;
		color: #999999;
		font-size: 13px;
	}
	.w85 {
		width: 85% !important;
	}
	.mr30 {
		margin-right: 30px;
	}
	.redColor {
		color: red;
	}
	.blueColor {
		color: #2671cc;
	}
}
.title-box {
	height: 32px;
	line-height: 32px;
	font-size: 14px;
}
</style>
